﻿import { format } from 'date-fns/format';

export class DateValueConverter {
  toView(value: string | Date, formatStr?: string): string {
    if (!value) {
      return '';
    }

    if (typeof value === 'string') {
      value = new Date(Date.parse(value));
    }

    if (formatStr) {
      return format(value, formatStr);
    } else {
      return format(value, 'dd.MM.yyyy');
    }
  }
}
